import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core'
import { ControlContainer, FormGroupDirective, ReactiveFormsModule } from '@angular/forms'
import { toFormControl } from '@core/utils/form-utils'
import { Select } from 'primeng/select'
import { IftaLabel } from 'primeng/iftalabel'
import { toSignal } from '@angular/core/rxjs-interop'
import { CountryService } from '@services/country.service'

@Component({
  selector: 'albert-country-select',
  standalone: true,
  imports: [ReactiveFormsModule, Select, IftaLabel],
  templateUrl: './albert-country-select.component.html',
  styleUrl: './albert-country-select.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ]
})
export class AlbertCountrySelectComponent {
  public readonly label = input.required<string>()
  public readonly inputId = input.required<string>()
  public readonly controlName = input.required<string>()
  public readonly placeholder = input<string>('')
  public readonly editable = input<boolean>(false)
  public readonly disabled = input<boolean>(false)
  public readonly required = input<boolean>(false)
  public readonly invalid = input<boolean>(false)

  private readonly countryService = inject(CountryService)
  private readonly parentGroupDir = inject(FormGroupDirective)
  public readonly control = computed(() => {
    return toFormControl(this.parentGroupDir.form.get(this.controlName()))
  })
  private readonly countries = toSignal(this.countryService.countries$, { initialValue: [] })
  public readonly countryOptions = computed(() =>
    this.countries().map(c => ({ label: c.label, value: c.country }))
  )

  public get showRequiredHint(): boolean {
    if (!this.required()) return false

    const val: unknown = this.control()?.value
    const isEmpty = val === null || val === undefined || val === ''
    return isEmpty && !this.disabled()
  }
}
